import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgLuckyBoxClaimedContentProps } from './msg-lucky-box-claimed-content';
import { MsgLuckyBoxClaimedContent } from './msg-lucky-box-claimed-content';

export interface MsgLuckyBoxClaimedProps extends MsgLuckyBoxClaimedContentProps {}

export const MsgLuckyBoxClaimed = memo(function MsgLuckyBoxClaimed({
  message,
}: MsgLuckyBoxClaimedProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgLuckyBoxClaimedContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
